import type { AdminRole } from '@/lib/api-admin';

/**
 * 관리자 구매확정 RBAC. be-order-lifecycle 계약:
 * `confirm-purchase` 의 @PreAuthorize 가 SUPER_ADMIN / OPS_ADMIN 만 허용한다.
 * (5개 타입드 액션의 orderActionRbac 와 별도 — 구매확정은 운영 권한 한정.)
 */
export const CONFIRM_PURCHASE_ROLES: ReadonlyArray<AdminRole> = ['SUPER_ADMIN', 'OPS_ADMIN'];

export const canConfirmPurchase = (roles: ReadonlyArray<AdminRole>): boolean =>
  CONFIRM_PURCHASE_ROLES.some((r) => roles.includes(r));

/** 주문상태 변경 [취소](입금대기 주문 취소) — 운영 관리자·고객 상담·최고 관리자만(BE 403 과 같은 기준). */
export const CANCEL_PENDING_ORDER_ROLES: ReadonlyArray<AdminRole> = ['SUPER_ADMIN', 'OPS_ADMIN', 'CS_AGENT'];

export const canCancelPendingOrder = (roles: ReadonlyArray<AdminRole>): boolean =>
  CANCEL_PENDING_ORDER_ROLES.some((r) => roles.includes(r));
